export const RDX_SESSION_LOCALE_UPDATE = 'rdx/session/locale/update';
export const RDX_SESSION_INIT = 'rdx/session/init';
export const RDX_SESSION_INIT_DONE = 'rdx/session/init/done';
export const RDX_SESSION_UPDATE = 'rdx/session/update';

export const changeLocale = (newLocale) => {
	return { 'type': RDX_SESSION_LOCALE_UPDATE, 'localeIntl': newLocale};
};
export const initSession = (key) => {
	return {
		'type' : RDX_SESSION_INIT,
		'initKey' : key
	};
};
export const initSessionDone = () => {
	return {
		'type' : RDX_SESSION_INIT_DONE
	};
};
export const updateSession = (jsonO) => {
	return {
		'type': RDX_SESSION_UPDATE,
		'jsonO' : jsonO
	};
};

export const RDX_OHB_SESSION_INIT = 'rdx/ohb/session/init';